let _btUsed = false;

export function btUsed(): boolean {
    return _btUsed;
}

export function markBtUsed(): void {
    _btUsed = true;
}

export function resetBt(): void {
    _btUsed = false;
}
